import React from 'react'
import styles from './Tab.less'
import classnames from 'classnames'

class Tab extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      activeIndex: 0
    }
  }

  handleClick = (index) => {
    if (index === this.state.activeIndex) return
    this.setState({
      activeIndex: index
    }, () => {
      setTimeout(() => {
        let xiaoKDOM = document.querySelector('#kd_cq_custom_xiao_k_ctrl')
        let nlpSearchDOM = document.querySelector('#kd_cq_custom_nlp_search_c')
        // kd-cq-custom-nlp-search-ctrl
        if (xiaoKDOM) {
          xiaoKDOM.style.cssText += `;display: ${index === 0 ? 'none' : 'flex'}`
        }
        if (nlpSearchDOM) {
          nlpSearchDOM.style.cssText += `;display: ${index === 0 ? 'block' : 'none'}`
        }
        xiaoKDOM = nlpSearchDOM = null
      }, 300)
    })
  }

  render () {
    const { activeIndex } = this.state
    const { model } = this.props
    console.log(model, 'model')
    return (
      <div className={styles.tab}>
        <div className={classnames(styles['tab-item'], { [styles.active]: activeIndex === 0 })} onClick={() => this.handleClick(0)}>
          <i className={classnames('kdfont kdfont-sousuo2', styles.icon)} />{KDApi.getLangMsg(model, 'tab.key0001') || '搜索'}
        </div>
        <div className={classnames(styles['tab-item'], { [styles.active]: activeIndex === 1 })} onClick={() => this.handleClick(1)}>
          <i className={classnames("kdfont kdfont-pinglun", styles.icon)} />{KDApi.getLangMsg(model, 'tab.key0002') || '对话'}
        </div>
      </div>
    )
  }
}

export default Tab